import {
  createMapFromObject,
  createObjectWithPreferredKeysFromArrayOfObjects,
  getArrayOfCopiedObjects,
} from './';

const getAssignedPathologists = (cases, caseId) => {
  const { pathologists } = cases.find((caseX) => caseX.id === caseId);
  return pathologists;
};

const getAssignedPathologistsIds = (cases, caseId) => {
  const { pathologists } = cases.find((caseX) => caseX.id === caseId);
  const pathologistIds = pathologists.map(pathologist => pathologist._id)
  return pathologistIds;
};

const getPathologistsIndexedByKey = (
  arrayOfObjects,
  propertiesToCopy,
  indexKey,
) => {
  const pathologists = getArrayOfCopiedObjects(
    arrayOfObjects,
    propertiesToCopy,
  );

  const pathologistsIndexedByKey = createMapFromObject(
    createObjectWithPreferredKeysFromArrayOfObjects(pathologists, indexKey)
  );

  return pathologistsIndexedByKey;
};

const hasAssignedPathologists = (cases, id) => {
  const assignedPathologists = getAssignedPathologists(cases, id);

  if (assignedPathologists.length === 0) {
    return false;
  }
  
  return true;
};

export {
  getAssignedPathologists,
  getAssignedPathologistsIds,
  getPathologistsIndexedByKey,
  hasAssignedPathologists,
};
